import React from "react";
import { createPortal } from "react-dom";
import Button from "@mui/material/Button";

const modalRoot = document.getElementById("modal-root") || document.body;

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: "#fff",
  borderRadius: 16,
  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  maxWidth: 400,
  width: "90%",
  padding: 24,
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
};

const continueButtonStyle = {
  backgroundColor: "#1976d2",
  color: "#fff",
  borderRadius: 8,
  padding: "8px 16px",
};

const stayButtonStyle = {
  backgroundColor: "#f0f0f0",
  color: "#333",
  borderRadius: 8,
  padding: "8px 16px",
  border: "1px solid #ccc",
};

const NavigationWarningModal = ({ show, onStay, onContinue }) => {
  if (!show) return null;

  return createPortal(
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginBottom: 12, fontSize: 18, textAlign: "left" }}>
          Confirm Action
        </h2>
        <p style={{ marginBottom: 24, fontSize: 14 }}>
          This link will open in a new tab. Click 'CONTINUE' to stay on the mentoring call and proceed.
        </p>
        <div style={buttonContainerStyle}>
          <Button
            variant="contained"
            style={continueButtonStyle}
            onClick={onContinue}
          >
            CONTINUE
          </Button>
          <Button
            variant="outlined"
            style={stayButtonStyle}
            onClick={onStay}
          >
            CANCEL
          </Button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default NavigationWarningModal;
